<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>INTERNATIONAL CONFERENCE</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">INTERNATIONAL CONFERENCE</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>

<section>
    <div class="container">
        <div class="row">
            <div class="col-md-6 col-sm-12">
                <div class="row">
                    <div class="col-md-12 col-sm-12 text-center border">
                        <h3>REDEFINING POSSIBILITIES:</h3>
                        <h4>CROSS MULTI-DISCIPLINARY APPROACHES TO GLOBAL CHALLENGES</h4>
                        <h5>(Hybrid Mode)</h5>
                        <h5>Supported by</h5>
                        <img src="assets/img/conference/drdo.png" class="cover-background" width="400"/>
                        <h5>Jointly Organized By</h5>
                    </div>
                    <div class="col-md-6 col-sm-12 py-3 text-center border">
                        <img src="assets/img/conference/Arlogo.png" class="cover-background" width="200"/>
                        <h6>Arni University Indora Kangra India</h6>
                    </div>
                    <div class="col-md-6 col-sm-12 py-3 text-center border">
                        <img src="assets/img/conference/inti.png" class="cover-background" width="200"/>
                        <h6>INTI International University malaysia</h6>
                    </div>
                    <div class="col-md-12 col-sm-12 p-0 m-0 text-center border">
                        <h4 class="text-center p-0 m-0">26th - 28th December 2024</h4>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-sm-12">
                <h4 class="text-center">ABOUT THE CONFERENCE</h4>
                <p>
                    This Conference aims to bring together the brightest minds from a wide array of disciplines,
                    fostering collaboration, innovation, dynamic exchanges between disciplines, exploring intersections
                    and knowledge exchange on a global scale. This conference attempts to break down the traditional
                    barriers that often separate academic disciplines, creating a vibrant platform where ideas can flow
                    freely across fields such as science and technology, health and medicine, social sciences,
                    humanities, business, economics, and environmental studies. By encouraging cross-disciplinary
                    dialogue, the conference aspires to address some of the most pressing challenges facing our world
                    today, including sustainability, global health,technological advancements, and ethical governance.
                </p>
                <p>Participants will engage in discussions that bridge the gaps between disciplines, leveraging unique
                    perspectives and methodologies to address pressing global challenges.This Conference is a step
                    towards a more integrated and collaborative approach to research and problem- solving. By bringing
                    together diverse perspectives and expertise, the conference seeks to inspire participants to think
                    beyond the confines of their disciplines and to contribute to a broader understanding of the complex
                    issues facing our world and the insights gained from this conference will contribute to a deeper
                    understanding of how integrated approaches can drive meaningful change on a global scale.</p>
            </div>

            <div class="col-md-6 col-sm-12 border border-5 text-center">
                <div class="row">
                    <div class="col-md-12 col-sm-12 my-3">
                        <img src="assets/img/conference/crc.png" class="cover-background" style="width: 400px;"/>
                        <hr class="border-dashed border-3"/>
                    </div>
                    <div class="col-md-12 col-sm-12 ">
                        <img src="assets/img/conference/scopus2.png" class="cover-background" style="width: 400px;"/>
                        <hr class="border-dashed border-3"/>
                    </div>
                    <div class="col-md-12 col-sm-12 my-2">
                        <img src="assets/img/conference/taylorgrp.png" class="cover-background" style="width: 400px;"/>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-sm-12 border text-center">
                <div class="row">
                    <div class="col-6 border">
                        <h3>CHIEF PATRON</h3>
                    </div>
                    <div class="col-6 border">
                        <h3>PATRON</h3>
                    </div>
                    <div class="col-6 border">
                        <h6>Dr. Vivek Singh</h6>
                        <p>Chancellor, Arni University, H.P, India</p>
                    </div>
                    <div class="col-6 border">
                        <h6>Prof.(Dr.) R.K. Pandey</h6>
                        <p>Vice Chancellor, Arni University, H.P, India</p>
                        <h6>Prof.(Dr.) Manish Kumar Srivastava</h6>
                        <p>Pro- Vice Chancellor, Arni University</p>
                    </div>

                    <div class="col-4 border">
                        <h6>CONVENER</h6>
                    </div>
                    <div class="col-4 border">
                        <h6>CO-CONVENER</h6>
                    </div>
                    <div class="col-4 border">
                        <h6>ORGANIZING SECRETARY</h6>
                    </div>

                    <div class="col-4 border">
                        <h6>Dr. Ashish Kumar Sharma</h6>
                        <p>HOD Dept. Mathematics, AU</p>
                    </div>
                    <div class="col-4 border">
                        <h6>Dr. Neha Salaria</h6>
                        <p>HOD School of Allied Health Sciences, AU</p>
                        <h6>Dr. Sunita Mahajan</h6>
                        <p>HOD CSA, AU</p>
                    </div>
                    <div class="col-4 border">
                        <h6>Dr. Gurvinder Singh</h6>
                        <p>Dean School of Engineering, AU</p>
                        <h6>Dr. Neeraj Bhandari</h6>
                        <p>Principal School of Pharmacy, AU</p>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-sm-12 border text-center">
                <div class="row">
                    <div class="col-md-6 col-sm-12">
                        <p class="text-secondary my-3"><a
                            href="https://drive.google.com/file/d/1mLIjiB9TWvh9_hWzFRyfw9UVPVBh3tCG/preview"
                            target="_blank"><b class="text-secondary text-decoration-underline">Download Conference
                            Brochure</b></a></p>
                    </div>
                    <div class="col-md-6 col-sm-12 text-decoration-underline">
                        <p class="text-secondary my-3 cursor-pointer text-decoration-underline"><b>Download Call For
                            Papers</b></p>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-sm-12 border text-center">
                <p class="my-3">After Fee Submission: <a
                    href="https://docs.google.com/forms/d/e/1FAIpQLSeTCPghPsiYbGANmF0gLBPISD9m8WmSWfOJUz6DdpcB8iksQA/viewform"
                    target="_blank"
                    class="text-secondary text-decoration-underline"><b>Register Conference</b></a></p>
            </div>
            <div class="col-md-6 col-sm-12 border text-center mt-3">
                <h5 class="my-3">Important Key Dates:</h5>
            </div>
            <div class="col-md-6 col-sm-12 border text-center mt-3">
                <h5 class="my-3">Registration Fee:</h5>
            </div>
            <div class="col-md-6 col-sm-12 border text-center">
                <p class="mt-3">Last Date of Abstract submission: 15th December 2024</p>
                <hr class="border-dashed border-2"/>
                <p>Last date of Full paper submission: 23rd of December</p>
                <hr class="border-dashed border-2"/>
                <p>Last date of Registration: 15th December 2024.</p>
            </div>
            <div class="col-md-6 col-sm-12 border text-center">
                <p class="mt-3">For Research Scholars: Rs 1000/- (Thousand Rupees only).</p>
                <hr class="border-dashed border-2"/>
                <p>For Foreign Authors: USD $50 (Fifty Dollars).</p>
                <hr class="border-dashed border-2"/>
                <p>For Academicians, Faculties, etc.: Rs 1500/- (Fifteen Hundred only).</p>
                <hr class="border-dashed border-2"/>
                <p>Student UG/PG (Attendees): Rs 500/- (Five Hundred Only).</p>
            </div>

            <h4 class="text-center mt-5 text-decoration-underline">CONTACT</h4>
            <div class="col-6 border text-center mt-3">
                <h5 class="my-3">Contact Us</h5>
            </div>
            <div class="col-6 border text-center mt-3">
                <h5 class="my-3">Address</h5>
            </div>
            <div class="col-6 border text-center">
                <div class="row">
                    <div class="col-md-6 col-sm-12 border text-center">
                        <p>Dr. Ashish Kumar Sharma</p>
                        <p>Convener</p>
                        <h6><i class="fa fa-mobile text-secondary"></i> <a href="tel:9149528365"> 9149528365 </a>
                            <i class="fa fa-comment text-secondary"></i> <a href="tel:9459612281"> 9459612281</a>
                        </h6>
                    </div>
                    <div class="col-md-6 col-sm-12 border text-center">
                        <p>Dr. Gurvinder Singh</p>
                        <p>Organizing Secretary</p>
                        <h6><i class="fa fa-mobile text-secondary"></i> <a href="tel:7986513723"> 7986513723</a>
                        </h6>
                    </div>
                    <div class="col-md-12 col-sm-12">
                        <i class="fa fa-envelope text-secondary"></i> <a href="mailto:conference@arniuniversity.edu.in">
                        Email: <b class="text-secondary text-wrap text-break">conference@arniuniversity.edu.in</b></a>
                    </div>
                </div>

            </div>
            <div class="col-6 border text-center">
                <p>Arni University, (Kathgarh), Tehsil Indora, Distt. Kangra, Himachal Pradesh Pin-176401</p>
            </div>

            <h4 class="text-center mt-5 text-decoration-underline">SCHEDULE AND PUBLISHED</h4>
            <div class="col-md-6 col-sm-12 border text-center mt-3">
                <h5 class="my-3">Day Wise Schedule</h5>
            </div>
            <div class="col-md-6 col-sm-12 border text-center mt-3">
                <h5 class="my-3">All Accepted Research Papers will be Published:</h5>
            </div>
            <div class="col-md-6 col-sm-12 border">
                <p class="mt-3">Day 1: Inauguration and Talk By Keynote Speakers</p>
                <hr class="border-dashed border-2"/>
                <p>Day 2: Technical and Valedictory Session.</p>
                <hr class="border-dashed border-2"/>
                <p>Day 3: Sight Seeing</p>
                <hr class="border-dashed border-2"/>
            </div>
            <div class="col-md-6 col-sm-12 border ">
                <p class="my-3">In UGC CARE/Scopus Indexed Journals.</p>
                <hr class="border-dashed border-2"/>
                <p>The Conference Proceedings will be published by CRC Press which is part of the Taylor & Francis
                    Group.</p>
                <hr class="border-dashed border-2"/>
                <p>Please note that Publication charges will be chargeable as per the rules of Journals.</p>
                <hr class="border-dashed border-2"/>
            </div>

            <h4 class="text-center mt-5 text-decoration-underline">SCOPE OF THE CONFERENCE</h4>
            <div class="col-md-12 col-sm-12 border text-center mt-3">
                <h6 class="my-3">In an era defined by rapid technological advancements, environmental changes, and evolving social
                    dynamics, addressing global challenges requires more than traditional, single-discipline approaches.
                    This conference provides a platform for interdisciplinary collaboration, fostering dialogue across
                    fields such as science, technology, humanities, social sciences, economics, and environmental
                    studies.</h6>
            </div>
            <div class="col-md-6 col-sm-12 border">
                <h5 class="text-secondary text-decoration-underline my-3">MANAGEMENT AND BUSINESS STUDIES</h5>
                <ul>
                    <li>Entrepreneurship and Innovation Ecosystems</li>
                    <li>Digital Marketing and Consumer Behavior</li>
                    <li>Business Ethics and Corporate Governance</li>
                    <li>Operations and Supply Chain Analytics</li>
                    <li>Human Resource Management in the Digital Age</li>
                    <li>Financial Technology (FinTech) and Risk Management</li>
                    <li>Data-Driven Decision Making in Management.</li>
                </ul>
            </div>
            <div class="col-md-6 col-sm-12 border">
                <h5 class="text-secondary text-decoration-underline my-3">ENGINEERING AND TECHNOLOGY</h5>
                <ul>
                    <li>Artificial Intelligence and Machine Learning in Engineering</li>
                    <li>Robotics and Autonomous Systems</li>
                    <li>Nanotechnology and Material Science</li>
                    <li>Cybersecurity and Information Assurance</li>
                    <li>Civil Engineering and Urban Infrastructure Development</li>
                    <li>Biomedical Engineering and Health Innovations.</li>
                    <li>Advanced Computing and Quantum Engineering.</li>
                </ul>
            </div>

            <h4 class="text-center mt-5 text-decoration-underline">SCOPE OF THE CONFERENCE</h4>
            <div class="col-md-12 col-sm-12 border border-double border-3 text-center mt-3">
                <h6 class="my-3">In an era defined by rapid technological advancements, environmental changes, and evolving social
                    dynamics, addressing global challenges requires more than traditional, single-discipline approaches.
                    This conference provides a platform for interdisciplinary collaboration, fostering dialogue across
                    fields such as science, technology, humanities, social sciences, economics, and environmental
                    studies.</h6>
            </div>
            <div class="col-md-6 col-sm-12 border border-double border-3">
                <h5 class="text-secondary text-decoration-underline my-3">MANAGEMENT AND BUSINESS STUDIES</h5>
                <ul>
                    <li>Entrepreneurship and Innovation Ecosystems</li>
                    <li>Digital Marketing and Consumer Behavior</li>
                    <li>Business Ethics and Corporate Governance</li>
                    <li>Operations and Supply Chain Analytics</li>
                    <li>Human Resource Management in the Digital Age</li>
                    <li>Financial Technology (FinTech) and Risk Management</li>
                    <li>Data-Driven Decision Making in Management.</li>
                </ul>
            </div>
            <div class="col-md-6 col-sm-12 border border-double border-3">
                <h5 class="text-secondary text-decoration-underline my-3">ENGINEERING AND TECHNOLOGY</h5>
                <ul>
                    <li>Artificial Intelligence and Machine Learning in Engineering</li>
                    <li>Robotics and Autonomous Systems</li>
                    <li>Nanotechnology and Material Science</li>
                    <li>Cybersecurity and Information Assurance</li>
                    <li>Civil Engineering and Urban Infrastructure Development</li>
                    <li>Biomedical Engineering and Health Innovations.</li>
                    <li>Advanced Computing and Quantum Engineering.</li>
                </ul>
            </div>
            <div class="col-md-6 col-sm-12 border border-double border-3">
                <h5 class="text-secondary text-decoration-underline my-3">PHARMACEUTICAL AND HEALTHCARE SCIENCES</h5>
                <ul>
                    <li>Pharmaceutical and Drug Delivery Systems</li>
                    <li>Pharmacovigilance and Drug SafetyClinical Pharmacy and Therapeutics</li>
                    <li>Nanotechnology and Material Science</li>
                    <li>Healthcare Management</li>
                    <li>Ethics in Pharmaceutical Research</li>
                    <li>Natural Products and Herbal Medicine</li>
                    <li>Personalized Medicine and Pharmacogenomics</li>
                    <li>Pharmaceutical Regulation and Policy</li>
                    <li>Global Health and Infectious Disease Control</li>
                </ul>
            </div>
            <div class="col-md-6 col-sm-12 border border-double border-3">
                <h5 class="text-secondary text-decoration-underline my-3">HEALTH SCIENCES AND MEDICINE</h5>
                <ul>
                    <li>Digital Humanities and Cultural Preservation</li>
                    <li>Art, culture and society</li>
                    <li>Ethics and Technology in Modern Society</li>
                    <li>Regional literature and languages</li>
                    <li>Interdisciplinary Approaches to Social Studies</li>
                    <li>Psychological Studies and Perspectives</li>
                    <li>Philosophy of Artificial Intelligence</li>
                    <li>Literature and Digital Media -Visual Arts and Design Thinking</li>
                </ul>
            </div>
            <div class="col-md-6 col-sm-12 border border-double border-3">
                <h5 class="text-secondary text-decoration-underline my-3">BASIC AND APPLIED SCIENCES</h5>
                <ul>
                    <li>Computational Biology</li>
                    <li>Environmental Science</li>
                    <li>Biotechnology and Genetic Engineering</li>
                    <li>Space Science</li>
                    <li>Astrophysics</li>
                    <li>Nuclear Science and Technology.</li>
                    <li>Pure and Applied Mathematics</li>
                    <li>Chemical Science</li>
                    <li>Environmental Chemistry</li>
                    <li>Forestry science</li>
                    <li>Marine Science</li>
                </ul>
            </div>
            <div class="col-md-6 col-sm-12 border border-double border-3">
                <h5 class="text-secondary text-decoration-underline my-3">AGRICULTURE AND ENVIRONMENTAL STUDIES</h5>
                <ul>
                    <li>Agroecology and Sustainable Farming Practices</li>
                    <li>Precision Agriculture and Smart Farming</li>
                    <li>Biotechnology in Cropimprovement</li>
                    <li>Agricultural Policy</li>
                    <li>Food Security</li>
                    <li>Climate-Resilient Agriculture</li>
                    <li>Soil Health and Nutrient Management</li>
                    <li>Water Resource Management in Agriculture</li>
                </ul>
            </div>
            <div class="col-md-6 col-sm-12 border border-double border-3">
                <h5 class="text-secondary text-decoration-underline my-3">LAW AND GOVERNANCE</h5>
                <ul>
                    <li>International Law and Global Governance</li>
                    <li>Intellectual Property Rights in the Digital Age</li>
                    <li>Environmental Law and Policy</li>
                    <li>Cyber Law and Digital Rights</li>
                    <li>Human Rights and Social Justice</li>
                    <li>Corporate Law and Business Ethics</li>
                    <li>Public Health Law and Ethics Visit near Dharamshala</li>
                </ul>
            </div>

            <h4 class="text-center mt-5 text-decoration-underline">COMMITTEE MEMBERS</h4>
            <div class="col-6 text-center border border-double border-3">
                <h5 class="text-secondary text-decoration-underline py-2">ORGANIZING COMMITTEE MEMBERS</h5>
            </div>
            <div class="col-6 border text-center border-double border-3 py-2">
                <h5 class="text-secondary text-decoration-underline">ADVISORY BOARD MEMBERS</h5>
            </div>
            <div class="col-6 border border-double border-3 pt-3">
                <h6>Dr. Samiksha Sharma</h6>
                <p>English</p>
                <hr class="border border-dashed bg-secondary border-2"/>

                <h6>Dr. Kapil Mohan</h6>
                <p>Naturopathy & Yogic Sciences</p>
                <hr class="border border-dashed bg-secondary border-2"/>

                <h6>Dr. Sharad Tripathi</h6>
                <p>Life Science</p>
                <hr class="border border-dashed bg-secondary border-2"/>

                <h6>Dr. Waseem Qayoom Kachroo</h6>
                <p>Psychology</p>
                <hr class="border border-dashed bg-secondary border-2"/>

                <h6>Dr. Ashish Kumar</h6>
                <p>Physics</p>
                <hr class="border border-dashed bg-secondary border-2"/>

                <h6>Mr. Irshad Ahmad Sofi</h6>
                <p>Management & Commerce</p>
                <hr class="border border-dashed bg-secondary border-2"/>

                <h6>Dr. Rakesh Kumar</h6>
                <p>English</p>
                <hr class="border border-dashed bg-secondary border-2"/>

                <h6>Dr. Brijesh Tewari</h6>
                <p>Economics</p>
                <hr class="border border-dashed bg-secondary border-2"/>

                <h6>Ms. Mehvish Showkat</h6>
                <p>Law</p>
                <hr class="border border-dashed bg-secondary border-2"/>

                <h6>Mr. Aman Sharma</h6>
                <p>Pharmacy</p>
                <hr class="border border-dashed bg-secondary border-2"/>

                <h6>Mr. Jayprakash Thakur</h6>
                <p>Agriculture</p>
                <hr class="border border-dashed bg-secondary border-2"/>

                <h6>Mr. Saurabh Sharma</h6>
                <p>Chemistry</p>
                <hr class="border border-dashed bg-secondary border-2"/>
            </div>
            <div class="col-6 border border-double border-3 pt-3">
                <h6>Prof. Rakesh Kumar</h6>
                <p>Department of Mathematics, Punjabi University.</p>
                <hr class="border border-dashed bg-secondary border-2"/>

                <h6>Dr. Prabhat Kumar Srivastava</h6>
                <p>Professor Deptt. of Computer Science and Engineering, IMS Engineering College Ghaziabad</p>
                <hr class="border border-dashed bg-secondary border-2"/>

                <h6>Prof. Zaheer Abbas</h6>
                <p>Department of Mathematics, BGSBU Rajouri, J&K.</p>
                <hr class="border border-dashed bg-secondary border-2"/>

                <h6>Prof (Dr) Vishwadeepak Singh Baghela</h6>
                <p>School of Computing Science & Engineering, Galgotias University, Greater Noida (UP), India</p>
                <hr class="border border-dashed bg-secondary border-2"/>

                <h6>Dr. Aditi Sharma</h6>
                <p>Associate Professor, CSE, Sybiosis Institute of Tech., SIU Pune, India.</p>
                <hr class="border border-dashed bg-secondary border-2"/>

                <h6>Dr. Gaurav Srivastava</h6>
                <p>Assistant Professor, CSE, PSIT Kanpur, India</p>
                <hr class="border border-dashed bg-secondary border-2"/>

                <h6>Dr. Urvashi Chugh</h6>
                <p>Associate Professor, IT, KIET, Ghaziabad, India</p>
                <hr class="border border-dashed bg-secondary border-2"/>

                <h6>Dr. Amit Chugh</h6>
                <p>Associate Professor, CSE, IMSEC Ghaziabad, India</p>
                <hr class="border border-dashed bg-secondary border-2"/>

                <h6>Dr. Sonia Juneja</h6>
                <p>Professor & Head Computer Science Department, IMS Engineering College,Ghaziabad, U.P., India</p>
                <hr class="border border-dashed bg-secondary border-2"/>

                <h6>Dr. Navneet Kumar Verma</h6>
                <p>Associate Professor, Vellore Institute of Technology Bhopal</p>
                <hr class="border border-dashed bg-secondary border-2"/>

                <h6>Dr. S.N.Rajan</h6>
                <p>Professor& Head Department of Information Tech., IMS Engineering College, Ghaziabad,U.P., India</p>
                <hr class="border border-dashed bg-secondary border-2"/>

                <h6>P. Ts. Dr. RajermaniThinakaran</h6>
                <p>Faculty of Data Science and Information Tech, INTI International University, Malaysia</p>
                <hr class="border border-dashed bg-secondary border-2"/>

                <h6>Ms. Jyotsna Pandey</h6>
                <p>Environment Science and Impact Analysis, Kshatriya Institutions, Telangana</p>
                <hr class="border border-dashed bg-secondary border-2"/>

                <h6>Prof. Vishal Gupta</h6>
                <p>Department of Mathematics, MM University, Ambala.</p>
                <hr class="border border-dashed bg-secondary border-2"/>

                <h6>Dr. Indra Mani</h6>
                <p>Vice-Chancellor, Vasantrao Naik Marathwada Krishi Vidyapeeth, Parbhani, India</p>
                <hr class="border border-dashed bg-secondary border-2"/>

                <h6>Dr. Anil Kumar Mishra</h6>
                <p>Principal Scientist Soil And Water Conservation Engineering, Water Technology Centre, Indian
                    Agricultural Research Institute, New Delhi, India.</p>
                <hr class="border border-dashed bg-secondary border-2"/>

                <h6>Prof. (Dr.) Mahesh Gandhi</h6>
                <p>President: Council of International Universities, HQ Germany.Prof. University Of Chicago, USA
                    Associate professor, IT, KIET, Ghaziabad, India</p>
                <hr class="border border-dashed bg-secondary border-2"/>

                <h6>Dr. Joanna Rosak Szyrocka Częstochowa</h6>
                <p>University of Technology, Joannarosak-Europe</p>
                <hr class="border border-dashed bg-secondary border-2"/>

                <h6>Mr Sarvesh Kumar</h6>
                <p>Professor in Computer Science and Engineering Department ICFAI University Jaipur</p>
                <hr class="border border-dashed bg-secondary border-2"/>

                <h6>Dr. Sonali Mathur</h6>
                <p>Professor & Head Department of Computer Science & Engineering, IMS Engineering College, Ghaziabad,
                    U.P. , India</p>
                <hr class="border border-dashed bg-secondary border-2"/>

                <h6>Dr. Ritesh Naik</h6>
                <p>Professor, Manipal University Jaipur, India .</p>
                <hr class="border border-dashed bg-secondary border-2"/>

                <h6>Dr. A. Rekkbie</h6>
                <p>Educationist & President Royal American University, New York USA.</p>
                <hr class="border border-dashed bg-secondary border-2"/>
            </div>
        </div>
    </div>
</section>
